import { render, staticRenderFns } from "./InvestorOnboardingRfcCurp.vue?vue&type=template&id=28b5b312&"
import script from "./InvestorOnboardingRfcCurp.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingRfcCurp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports